export const API_URL = process.env.VUE_APP_API_URL;
export const GOFAR_SERVICE_URL = process.env.VUE_APP_GOFAR_SERVICE_URL;
export const ENV = process.env.VUE_APP_ENV || 'dev';
export const DEFAULT_SUBSCRIPTION_PLAN = process.env.VUE_APP_DEFAULT_SUBSCRIPTION_PLAN || 'gofar_unlimited_yearly_1'; 

export const PAYMENTS = {
  PAYPAL_MERCHANT_ID: process.env.VUE_APP_PAYPAL_MERCHANT_ID,
  // it is a publishable key hence, it is safe to strore in frontend env variable
  STRIPE: process.env.VUE_APP_STRIPE_KEY
};

export const HTTP_STATUS_CODES = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_ERROR: 500
};

export const HTTP_METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
};

export const ROLES = {
  ADMIN: 'admin',
  AUTHENTICATED: 'authenticated',
  FLEET_DRIVER: 'fleetDriver',
  FLEET_ADMIN: 'fleetAdmin'
};

export const SUCCESS_HTTP_STATUS_CODES = [HTTP_STATUS_CODES.SUCCESS, HTTP_STATUS_CODES.NOT_FOUND];
